import { useEffect } from "react";
import { motion } from "framer-motion";
import { Header, Footer } from "../components/Layout";
import { HERO_EYEBROW, HERO_TITLE, HERO_SUB_LATE } from "../lib/animations";

const SORO_SCRIPT_SRC = "https://app.trysoro.com/api/embed/6acdfc99-b5ec-420d-b08d-ffca434786cd";

export default function BlogPage() {
  useEffect(() => {
    // Inject Soro embed script once; leave it in the DOM so subsequent visits
    // find the existing tag and Soro can re-hydrate the mount point.
    if (document.querySelector(`script[src="${SORO_SCRIPT_SRC}"]`)) return;
    const script = document.createElement("script");
    script.src = SORO_SCRIPT_SRC;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <main className="min-h-screen bg-[#050505]" data-testid="blog-page">
      <Header />

      <section className="pt-32 pb-12 md:pt-40 md:pb-16 px-6 md:px-8" data-testid="blog-hero">
        <div className="max-w-[1400px] mx-auto">
          <motion.p
            className="font-mono text-xs md:text-sm tracking-[0.2em] uppercase text-[#FF2A00] mb-4"
            {...HERO_EYEBROW}
          >
            The Log
          </motion.p>
          <motion.h1
            className="font-display text-5xl md:text-7xl lg:text-8xl tracking-tight mb-6"
            {...HERO_TITLE}
          >
            DISPATCHES
          </motion.h1>
          <motion.p
            className="text-lg md:text-xl text-[#A3A3A3] max-w-2xl"
            {...HERO_SUB_LATE}
          >
            Notes from the workshop. Progress reports. Manifesto expansions.
          </motion.p>
        </div>
      </section>

      <section className="pb-24 md:pb-32 px-6 md:px-8" data-testid="blog-content">
        <div className="max-w-[1400px] mx-auto">
          <div
            id="soro-blog"
            data-testid="soro-blog-embed"
            className="min-h-[400px]"
          />
        </div>
      </section>

      <Footer />
    </main>
  );
}
